import { createFileRoute } from '@tanstack/react-router';
import { ReportsPage } from '../../features/reports/ReportsPage.jsx';

export const Route = createFileRoute('/_app/reports/')({ component: ReportsPage });
